export const context = {
  uamsAuth: "/uams-auth",
  uamsAdmin: "/uams-admin",
  sunflower: "/sunflower",
}
